import { Home, Task, Sms, WalletMoney, Setting2, Book, DollarSquare, Building, Health, Teacher, MessageText, Mobile, Video } from 'iconsax-react';
import React from 'react';

export const MenuSuperAdminList = ({ badgeCount, billingBadgeCount, managerSubsBadgeCount }) => [
    {
        title: 'Dashboard',
        iconStyle: <span><Home size={16} color="currentColor" /></span>,
        to: '/superadmin/dashboard',
    },
    { title: <hr style={{ margin: '8px 16px', borderTop: '1px solid #e5e7eb', opacity: 0.6 }} />, classsChange: 'menu-title' },
    {
        title: 'Anagrafiche',
        classsChange: 'mm-collapse',
        iconStyle: <span><Task size={16} color="currentColor" /></span>,
        content: [
            { title: 'Strutture Sportive', to: 'superadmin/anagrafiche/strutture-sportive' },
            { title: 'Player', to: 'superadmin/anagrafiche/player' },
            { title: 'Junior', to: 'superadmin/anagrafiche/junior' },
            { title: 'Discipline sportive', to: 'superadmin/anagrafiche/discipline' },
        ],
    },
    {
        title: 'Valida documenti',
        iconStyle: <span><Sms size={16} color="currentColor" /></span>,
        to: '/superadmin/documenti',
        badge: badgeCount,
    },
    { title: <hr style={{ margin: '8px 16px', borderTop: '1px solid #e5e7eb', opacity: 0.6 }} />, classsChange: 'menu-title' },
    {
        title: 'Abbonamenti',
        classsChange: 'mm-collapse',
        iconStyle: <span><Book size={16} color="currentColor" /></span>,
        content: [
            { title: 'Elenco Abbonamenti', to: 'superadmin/booking/subscriptions' },
            { title: 'Abbonamenti utenti', to: 'superadmin/booking/userSubscriptions' },
        ],
    },
    {
        title: 'Corsi e squadre',
        classsChange: 'mm-collapse',
        iconStyle: <span><Health size={16} color="currentColor" /></span>,
        content: [
            { title: 'Elenco Corsi', to: 'superadmin/booking/courses' },
            { title: 'Corsi utenti', to: 'superadmin/booking/userCourses' },
            { title: 'Squadre', to: 'superadmin/booking/userCoursesTeams' },
        ],
    },
    {
        title: 'Impianti',
        classsChange: 'mm-collapse',
        iconStyle: <span><Building size={16} color="currentColor" /></span>,
        content: [
            { title: 'Anagrafica Impianti', to: 'superadmin/booking/facilities' },
            { title: 'Prenotazioni impianti', to: 'superadmin/booking/userFacilities' },
        ],
    },
    {
        title: 'Maestri',
        classsChange: 'mm-collapse',
        iconStyle: <span><Teacher size={16} color="currentColor" /></span>,
        content: [
            { title: 'Anagrafica maestri', to: 'superadmin/anagrafiche/maestri' },
            { title: 'Elenco Lezioni', to: 'superadmin/booking/lessons' },
            { title: 'Prenotazioni lezioni', to: 'superadmin/booking/userLessons' },
        ],
    },
    { title: <hr style={{ margin: '8px 16px', borderTop: '1px solid #e5e7eb', opacity: 0.6 }} />, classsChange: 'menu-title' },
    {
        title: 'Richieste fatturazione',
        iconStyle: <span><DollarSquare size={16} color="currentColor" /></span>,
        to: 'superadmin/billing/requests',
        badge: billingBadgeCount,
    },
    {
        title: 'Fatture e ricevute',
        iconStyle: <span><WalletMoney size={16} color="currentColor" /></span>,
        to: 'superadmin/booking/userTransactions',
    },
    {
        title: 'DonAction',
        iconStyle: <span><WalletMoney size={16} color="currentColor" /></span>,
        to: '/superadmin/referral',
    },
    { title: <hr style={{ margin: '8px 16px', borderTop: '1px solid #e5e7eb', opacity: 0.6 }} />, classsChange: 'menu-title' },
    {
        title: 'Abbonamenti Manager',
        iconStyle: <span><Setting2 size={16} color="currentColor" /></span>,
        badge: managerSubsBadgeCount,
        to: 'superadmin/manager-subscriptions',
    },
    {
        title: 'Pagine parlanti',
        iconStyle: <span><MessageText size={16} color="currentColor" /></span>,
        to: 'superadmin/pagine-parlanti',
    },
    {
        title: 'Post per tutti',
        iconStyle: <span><MessageText size={16} color="currentColor" /></span>,
        to: 'superadmin/post-per-tutti',
    },
    {
        title: "Pagine dell'app",
        iconStyle: <span><Mobile size={16} color="currentColor" /></span>,
        to: 'superadmin/pagine-app',
    },
    {
        title: 'Video di presentazione',
        iconStyle: <span><Video size={16} color="currentColor" /></span>,
        to: 'superadmin/video-presentazione',
    },
    {
        // Una voce sola: le pagine di impostazione hanno il loro menu intermedio (layouts/MenuImpostazioni.js)
        title: 'Impostazioni',
        iconStyle: <span><Setting2 size={16} color="currentColor" /></span>,
        to: 'superadmin/strumenti/certificati-medici',
        attivoSu: ['superadmin/strumenti/', 'superadmin/manager-subscriptions/settings'],
    },
]
